import React, { useEffect, useState,useRef } from "react";
import axios from "axios";
import "./LoginIssues.css";
import { formatDateTime } from "../../utils/formatTimeDate";

const LoginIssues = () => {
    const [issues, setIssues] = useState([]);
    const [loading, setLoading] = useState(false);
    const tableWrapperRef = useRef(null);
    const [search, setSearch] = useState("");
    const [reasonFilter, setReasonFilter] = useState("");
    const [showLeftArrow,setShowLeftArrow] = useState(false);
    const [showRightArrow,setShowRightArrow] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchIssues(page);
    }, [page]);

    const scrollLeft = () => {

   tableWrapperRef.current.scrollBy({

      left: -300,

      behavior: "smooth"

   });

};


const scrollRight = () => {

   tableWrapperRef.current.scrollBy({

      left: 300,

      behavior: "smooth"

   });

};

   const handleTableScroll = () => {

   const element =
      tableWrapperRef.current;

   if (!element) return;

   const {

      scrollLeft,

      scrollWidth,

      clientWidth

   } = element;


   // SHOW LEFT

   setShowLeftArrow(
      scrollLeft > 10
   );


   // SHOW RIGHT

   setShowRightArrow(

      scrollLeft + clientWidth < scrollWidth - 10

   );

};

useEffect(() => {

   const element =
      tableWrapperRef.current;

   if (!element) return;

   handleTableScroll();

   element.addEventListener(
      "scroll",
      handleTableScroll
   );

   return () => {

      element.removeEventListener(
         "scroll",
         handleTableScroll
      );

   };

}, []);

    const fetchIssues = async (pageNum = 1) => {
        setLoading(true);

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/admin/login-issues?page=${pageNum}&limit=10`,
                {
                    withCredentials: true,
                }
            );

            setIssues(res.data.data || []);
            setTotalPages(res.data.totalPages || 1);
            setPage(res.data.page || 1);

        } catch (error) {
            console.error("Error fetching email issues:", error);
        } finally {
            setLoading(false);
        }
    };

    // Filters
    const filteredIssues = issues.filter((issue) => {
        return (
            (!reasonFilter || issue.reason === reasonFilter) &&
            (
                issue.email?.toLowerCase().includes(search.toLowerCase()) ||
                issue.reason?.toLowerCase().includes(search.toLowerCase())
            )
        );
    });


    const getReasonClass = (reason) => {

   const value =
      reason.toLowerCase();

   // CRITICAL

   if (
      value.includes("server") ||
      value.includes("network") ||
      value.includes("too many") ||
      value.includes("api error")
   ) {
      return "critical";
   }

   // WARNING

   if (
      value.includes("wrong password") ||
      value.includes("captcha") ||
      value.includes("not verified")
   ) {
      return "warning";
   }

   // INFO

   if (
      value.includes("popup") ||
      value.includes("cancel") ||
      value.includes("closed")
   ) {
      return "info";
   }

   // DEFAULT

   return "default";

};

    return (
        <div className="issues-container">

            {/* Header */}
            <div className="issues-header">
                <h2>Login Issues</h2>
            </div>

            {/* Filters */}
            <div className="issues-filters">

                <input
                    type="text"
                    placeholder="Search by email or reason..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="issues-input"
                />

                <select
                    value={reasonFilter}
                    onChange={(e) => setReasonFilter(e.target.value)}
                    className="issues-select"
                >
                    <option value="">All Reasons</option>
                    <option value="Wrong password">
                        Wrong Password
                    </option>

                    <option value="Too many login attempts">
                        Too Many Attempts
                    </option>

                    <option value="Captcha failed">
                        Captcha Failed
                    </option>

                    <option value="User not found">
                        User Not Found
                    </option>
                </select>
            </div>

            {/* Table */}
            {/* TABLE CONTAINER */}
            {/* TABLE SCROLL CONTROLS */}



<div className="issues-table-container">

    {/* LEFT SCROLL BUTTON */}
<div className="table-scroll-controls">

   {showLeftArrow && (

      <button

         className="table-nav-btn"

         onClick={scrollLeft}

      >

         ←

      </button>

   )}


   {showRightArrow && (

      <button

         className="table-nav-btn"

         onClick={scrollRight}

      >

         →

      </button>

   )}

</div>
    


    {/* TABLE WRAPPER */}

    <div

        className="issues-table-wrapper"

        ref={tableWrapperRef}

    >

        <table className="issues-table">

            <thead>

                <tr>

                    <th>Email</th>

                    <th>Login Type</th>

                    <th>Reason</th>

                    <th>IP Address</th>

                    <th>Status</th>

                    <th>Date / Time</th>

                </tr>

            </thead>

            <tbody>

                {loading ? (

                    <tr>

                        <td
                            colSpan="6"
                            className="text-center"
                        >

                            Loading...

                        </td>

                    </tr>

                ) : filteredIssues.length === 0 ? (

                    <tr>

                        <td
                            colSpan="6"
                            className="text-center"
                        >

                            No issues found

                        </td>

                    </tr>

                ) : (

                    filteredIssues.map((issue) => (

                        <tr key={issue._id}>

                            <td>

                                {issue.email ||

                                 issue.meta?.enteredEmail ||

                                 "Unknown"}

                            </td>

                            <td>

                                <span className="login-badge">

                                    {issue.loginType}

                                </span>

                            </td>

                            <td>

                                <span

                                    className={

                                       `reason-badge
                                        ${getReasonClass(issue.reason)}`

                                    }

                                >

                                    {issue.reason}

                                </span>

                            </td>

                            <td>

                                {issue.ipAddress}

                            </td>

                            <td>

                                <span

                                    className={

                                       issue.resolved

                                       ? "status-resolved"

                                       : "status-pending"

                                    }

                                >

                                    {

                                      issue.resolved

                                      ? "Resolved"

                                      : "Pending"

                                    }

                                </span>

                            </td>

                            <td
                               style={{
                                  fontSize: '12px'
                               }}
                            >

                                {formatDateTime(
                                   issue.createdAt
                                )}

                            </td>

                        </tr>

                    ))

                )}

            </tbody>

        </table>

    </div>


    {/* RIGHT SCROLL BUTTON */}

    

</div>


{/* PAGINATION */}

<div className="pagination">

    <button

        disabled={page === 1}

        onClick={() => setPage(page - 1)}

    >

        Prev

    </button>

    <span>

        Page {page} of {totalPages}

    </span>

    <button

        disabled={page === totalPages}

        onClick={() => setPage(page + 1)}

    >

        Next

    </button>

</div>
        </div>
    );
};

export default LoginIssues;